import {
  ConfListElementFragmentFragment,
  ConfListFragmentFragment,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { ConfList, ConfListElement } from "src/types/confList";

export const mapToConfListElement = (
  element: ConfListElementFragmentFragment
): ConfListElement => ({
  code: element.code,
  name: element.name,
  disabled: element.disabled,
});

export const mapToConfList = (confList: ConfListFragmentFragment): ConfList => ({
  code: confList.code,
  name: confList.name,
  elements: confList.elements.map(mapToConfListElement),
});
